import type { ElementState, StatState } from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const statState: StatState = {
  alertEvent: elementSate,
};

export const StatStateModule = {
  namespaced: true,
  state: statState,
  actions,
  mutations,
  getters,
};
